module.exports = __webpack_public_path__ + "static/img/0000镇赉叫号.5328d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000镇赉叫号.jpg
// module id = KPrB
// module chunks = 0